import { render, staticRenderFns } from "./offices.vue?vue&type=template&id=2795b02c&"
import script from "./offices.vue?vue&type=script&lang=js&"
export * from "./offices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports